<template>
  <div class="main-view pricing-container">
		<div class="bg-container pricing-hero" :style="{'background-image': 'url(' + require(`../assets/img/bgs/hero-bg-02.svg`) + ')'}">
			<div class="template-inner">
				<h1 class="hero-header">Powerful, affordable<br> employee engagement</h1>
				<p class="hero-body">Evergrow is affordable for companies of any scale. Keeping your team motivated means investing in ways that incentivize great performance, enable peer recognition, foster feedback, deliver value beyond base compensation, and encourage wellness. For many companies, it’s just too expensive and complicated to fund and integrate all of these separate programs. Evergrow changes that equation. It’s a next generation, all-in-one employee engagement solution that transforms workplace motivation by using AI to create a one-to-one personalized&nbsp;engagement&nbsp;journey.</p>
			</div>
		</div>
		<!-- TIER PRICING -->
		<section class="pricing-tier-container flex-row template-inner">
			<div class="pricing-column first-col one-quarter">
				<div class="pricing-container-top">
					<p class="pricing-tier-heading">Evergrow</p>
					<p class="pricing-points">500</p>
					<p class="team-info">For teams of<br> 500 members or less</p>
					<img  src="@/assets/img/bgs/white-wave-pricing.svg" alt="">
				</div>
				<div class="pricing-container-bottom">
					<p class="dollar-price">$5.00</p>
					<p class="team-info">Per member per month</p>
					<button @click="$router.push('/book-a-demo')">book a demo</button>
				</div>
			</div>
			<div class="pricing-column second-col one-quarter">
				<div class="pricing-container-top">
					<p class="pricing-tier-heading">Evergrow</p>
					<p class="pricing-points">1,000</p>
					<p class="team-info">For teams of<br> 501-1,000 members</p>
					<img src="@/assets/img/bgs/white-wave-pricing.svg" alt="">
				</div>
				<div class="pricing-container-bottom">
					<p class="dollar-price">$4.50</p>
					<p class="team-info">Per member per month</p>
					<button @click="$router.push('/book-a-demo')">book a demo</button>
				</div>
			</div>
			<div class="pricing-column third-col one-quarter">
				<div class="pricing-container-top">
					<p class="pricing-tier-heading">Evergrow</p>
					<p class="pricing-points">2,500</p>
					<p class="team-info">For teams of<br> 1,001-2,500 members</p>
					<img src="@/assets/img/bgs/white-wave-pricing.svg" alt="">
				</div>
				<div class="pricing-container-bottom">
					<p class="dollar-price">$4.00</p>
					<p class="team-info">Per member per month</p>
					<button @click="$router.push('/book-a-demo')">book a demo</button>
				</div>
			</div>
			<div class="pricing-column fourth-col one-quarter">
				<div class="pricing-container-top">
					<p class="pricing-tier-heading">Evergrow</p>
					<p class="pricing-points">2,500+</p>
					<p class="team-info">For teams of<br> 2,501 or more members</p>
					<img src="@/assets/img/bgs/white-wave-pricing.svg" alt="">
				</div>

				<div class="pricing-container-bottom">
					<p class="dollar-price">$3.50</p>
					<p class="team-info">Per member per month</p>
					<button @click="$router.push('/book-a-demo')">book a demo</button>
				</div>
			</div>
		</section>

		<div class="tax-and-fees">
			<p>Plus additional taxes and fees where applicable.</p>
		</div>

		<!-- TREES PLANTED -->
		<div class="trees-per-month flex-row">
			<div class="stroke"></div>
			<div class='trees-per-month-inner flex-row'>
				<img src="@/assets/img/icons/tree-green.svg" alt="tree icon">
				<p>5</p>
				<p>trees planted for every<br> member per month</p>
			</div>
			<div class="stroke"></div>
		</div>

		<!-- ROADMAP -->
		<section class="roadmap">
			<div class="template-inner">
				<img src="@/assets/img/icons/pricing/pricing-illustration.svg" alt="group of people gardening">
				<h2>Our innovation roadmap</h2>
				<p>Evergrow is built as a future-friendly multi-experience technology platform that enables fast iteration. We’re already planning <span>new features and free updates</span> to include sales incentives, video recognition, family sharing, channel incentives, 3rd party app and marketplace integrations and much more.</p>
			</div>
		</section>
		<div class="template-inner">
			<div class="line-break"></div>
		</div>
		<section class="partners">
			<p>Evergrow is featured in these leading online app marketplaces:</p>

			<div class="partners-inner flex-row template-inner">
				<img src="@/assets/img/logos/MicrosoftAppSource.png" class="partner-logo "  alt="Microsoft App Source logo">
				<img src="@/assets/img/logos/adp-logo-new.png" class="partner-logo adp" alt="ADP logo">
				<img src="@/assets/img/logos/partnerstack_logo.png" class="partner-logo"  alt="PartnerStack logo">
			</div>
		</section>

		<Demo></Demo>

  </div>
</template>

<script>
	import Demo from "../components/Demo";
	export default {
		name: 'Pricing',
		components: {
			Demo
		},
	}
</script>

<style lang="stylus" scoped>
// ----- general styles -----
	button 
		box-shadow 0px 20px 40px #00000033

	.pricing-container
		text-align center
		box-sizing: border-box

	// ----- header styles -----
	.bg-container.pricing-hero
		text-align center
		background center bottom / cover no-repeat
		display flex
		flex-direction column
		justify-content center
		align-items center
		padding 270px 0

	// ----- Pricing tier cols -----
	.pricing-tier-container
		margin-top: -180px
		flex-wrap wrap

	.pricing-column
		border-radius 30px
		box-shadow 0px 20px 40px #00000026

	.pricing-container-top
		position: relative
		padding 25px 48px 40px
		border-radius: 30px 30px 0 0

	.pricing-container-top img
		width: 100%
		position absolute
		left 0
		bottom -3px

	.pricing-container-bottom
		padding 30px 20px
		.team-info 
			padding-bottom 60px
	
	.pricing-points
		font-size: 46px
		font-weight 600

	.pricing-tier-heading
		font-size 20px
		padding 35px  0 0 0
		margin-bottom: 20px;

	.team-info 
		font-weight 300

	.dollar-price  
		color:#00A562
		font-size 60px

	.first-col .pricing-container-top
		background-color #ffdeb5
		padding 25px 44px 40px
		.pricing-points, .pricing-tier-heading
			color: #FF8D03

	.second-col .pricing-container-top
		background-color #ADE5FF
		padding: 25px 57px 40px;
		.pricing-points, .pricing-tier-heading
			color: #00AEFF

	.third-col .pricing-container-top
		background-color #FFD5EE
		.pricing-points, .pricing-tier-heading
			color: #FF31AF

	.fourth-col .pricing-container-top 
		background-color #9FE39F
		padding 24px 39px 40px
		.pricing-points, .pricing-tier-heading
			color: #008200

	.tax-and-fees 
		margin-top 50px

	// ----- trees planted -----
	.trees-per-month
		margin 100px 0
		justify-content center
		align-items center
		
	
	.stroke 
		border-top 1.5px solid #CCCCCC
		height 2px
		width 18%

	.trees-per-month-inner
		width 41%
		padding 60px
		border 2px solid #CCCCCC
		border-radius 30px
		justify-content center
		align-items center

		img
			margin-right 20px
			width 60px

	.trees-per-month-inner p:first-of-type
		font-size 72px
		font-weight 500
		color #00A562
		margin-right 20px
		padding-bottom 0
		line-height 1
		
	.trees-per-month-inner p:last-of-type
		font-size 20px
		font-weight 400
		color #00A562
		line-height 1.5
		text-align left
		padding-bottom 0

// ----- road map -----
	.roadmap h2 
		font-size 50px
		font-weight 300
		margin 30px auto 15px


	.roadmap img
		width 540px

	.roadmap p 
		width 70%
		margin 0 auto
		padding-bottom 0
		line-height 28px

	.line-break
		border-top 2px solid #CCCCCC
		opacity 1
		height 2px
		// width 68%
		margin 70px 0

	.roadmap span 
		color #00A562
		font-weight 500

// ----- PARTNERS -----
	.partners  
		padding-bottom 80px
		
	.partners-inner
		margin-top 30px
		max-width 870px
	
	.partners p
		font-size 21px
		font-weight 500

	.partners img 
		padding 0 15px
		width 250px

	.partner-logo.adp 
		width 120px
		

	@media (max-width: 1000px)
		.bg-container.pricing-hero
			justify-content flex-start
			padding 80px 0
			
			h1.hero-header 
				font-size 54px
				margin 80px 0 40px
				
		.pricing-tier-container
			margin-top 40px
			flex-direction column
			
			.pricing-column
				width 100% !important
				margin-bottom 80px
				
			.pricing-points
				font-size 50px
				line-height 1
				padding-top 10px
				
			.team-info
				font-size 18px
				
			.pricing-container-bottom
				padding-bottom 60px
			
			.pricing-container-bottom .dollar-price
				line-height 1
				
			.pricing-container-bottom .team-info
				padding-bottom 30px
				
		.tax-and-fees
			margin-top 0
			
			p
				padding 0
				
		.trees-per-month 
			margin 90 0
			
			.trees-per-month-inner
				width 80%
				padding 40px 0
				
				&.flex-row
					flex-direction flex-row
					justify-content center
					flex-wrap wrap
				img
					margin 0 10px 20px 0
					
				p:first-of-type
					margin 0 0 20px 0
					line-height 1
				
				p:last-of-type
					text-align center	
					width 100%
			
			.stroke
				display none
				
		.roadmap img
			width 100%
			
		.roadmap p
			width 100%
			
		.partners
			width 80%
			margin 0 auto
			
		.partners-inner
			flex-direction column !important
			
		.partners img
			width 100%
			padding 0 0 36px 0
			
</style>

